"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEVEN_NUMBER = exports.TWELVE_NUMBER = exports.THREE_NUMBER = exports.TWO_NUMBER = exports.FIVE_HUNDRED = exports.ONE_HUNDRED = exports.MEDIUM_WIDTH = exports.MIN_WIDTH = exports.SIX_LENGTH = exports.FIVE_LENGTH = exports.FOUR_LENGTH = exports.NEXT_CLASS = exports.PREV_CLASS = exports.HIDE_CLASS = exports.ACTIVE_CLASS = exports.ARROW_BUTTONS = exports.TAB_BORDER_CLASS = exports.TAB_REGULAR_CLASS = exports.TAB_CONTENT_CLASS = exports.TAB_BODY_CLASS = exports.TAB_CLASS = exports.TAB_CONTAINER_CLASS = exports.TAB_HEADER_CLASS = exports.MOLECULA = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.MOLECULA = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tabs-group");
exports.TAB_HEADER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tab-header");
exports.TAB_CONTAINER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tabs");
exports.TAB_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tab");
exports.TAB_BODY_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tab-body");
exports.TAB_CONTENT_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tab-content");
exports.TAB_REGULAR_CLASS = "".concat(exports.TAB_CLASS, "-regular");
exports.TAB_BORDER_CLASS = "".concat(exports.TAB_CONTAINER_CLASS, "-border");
exports.ARROW_BUTTONS = 'arrow-buttons';
exports.ACTIVE_CLASS = 'active';
exports.HIDE_CLASS = 'hide';
exports.PREV_CLASS = 'prev';
exports.NEXT_CLASS = 'next';
exports.FOUR_LENGTH = 4;
exports.FIVE_LENGTH = 4;
exports.SIX_LENGTH = 4;
exports.MIN_WIDTH = 551;
exports.MEDIUM_WIDTH = 650;
exports.ONE_HUNDRED = 100;
exports.FIVE_HUNDRED = 500;
exports.TWO_NUMBER = 2;
exports.THREE_NUMBER = 3;
exports.TWELVE_NUMBER = 12;
exports.SEVEN_NUMBER = 7;
